module.exports = __webpack_public_path__ + "img/github-1.61bd16ad.jpg";